import { render, staticRenderFns } from "./PublisherDashboardTopPluginFilter.vue?vue&type=template&id=11a25882&scoped=true&"
import script from "./PublisherDashboardTopPluginFilter.vue?vue&type=script&lang=js&"
export * from "./PublisherDashboardTopPluginFilter.vue?vue&type=script&lang=js&"
import style0 from "./PublisherDashboardTopPluginFilter.vue?vue&type=style&index=0&id=11a25882&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a25882",
  null
  
)

export default component.exports